import { business } from '../../../shared/config/site';

/**
 * The phone thumb zone.
 *
 * Pinned to the bottom, present at every scroll position, two real mechanisms
 * and no third option competing with them. Hidden from large viewports where
 * the header already carries the number.
 */
export function ActionDock() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[color:var(--ink-600)] lg:hidden"
      style={{ background: 'rgba(7, 9, 12, 0.97)', paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-stretch">
        <a
          href={business.telephoneHref}
          className="u-display flex min-h-[3.5rem] flex-[2] items-center justify-center gap-2 bg-[color:var(--signal-500)] px-4 text-[0.95rem] text-[color:var(--ink-900)] transition-opacity active:opacity-80"
          style={{ transitionDuration: 'var(--t-tap)', transitionTimingFunction: 'var(--e-settle)' }}
        >
          Call {business.telephoneDisplay}
        </a>
        <a
          href={business.directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="u-label flex min-h-[3.5rem] flex-1 items-center justify-center px-4 text-center text-[color:var(--bone-100)] transition-colors active:text-[color:var(--signal-400)]"
          style={{ transitionDuration: 'var(--t-tap)', transitionTimingFunction: 'var(--e-settle)' }}
        >
          Directions
        </a>
      </div>
    </div>
  );
}
